












































































import Row from '@/views/molecules/Row.vue'
import TextBox from '@/views/atoms/TextBox.vue'
import FromTo from '@/views/molecules/FromTo.vue'
import BlueButton from '@/views/atoms/BlueButton.vue'
import TextDatePicker from '@/views/molecules/NoStoreTextDatePicker.vue'
import store from '@/store'
import CheckBox from '@/views/atoms/CheckBox.vue'
import SelectBox from '@/views/atoms/SelectBox.vue'

export default
  name: 'Search'

  components: {
    Row
    TextBox
    FromTo
    BlueButton
    TextDatePicker
    CheckBox
    SelectBox
  }

  data: () ->
    param: {}
  props:
    is_comp:
      type: Boolean
      default: true
    customsBrokerListData:
      type: Array
      default: -> []
  methods: {
    save_click: () ->
      postParam = 
        ship_name: @param.ship_name
        booking: @param.booking
        loading_area: @param.loading_area
        landing_area: @param.landing_area
        shipper_name: @param.shipper_name
        departure_date_plan_from: @param.departure_date_plan_from
        departure_date_plan_to: @param.departure_date_plan_to
        cut_date: @param.cut_date
        pick_up_date_from: @param.pick_up_date_from
        pick_up_date_to: @param.pick_up_date_to
        ledger_number: @param.ledger_number
        cut_datetime_from: @param.cut_datetime_from
        cut_datetime_to: @param.cut_datetime_to
        comp: false
        customs_broker_id: @param.customs_broker_id
      if @param.cut_datetime_from
        postParam.cut_datetime_from = @param.cut_datetime_from + ' 00:00:00'
      if @param.cut_datetime_to
        postParam.cut_datetime_to = @param.cut_datetime_to + ' 23:59:59'
      if @param.comp
        postParam.comp = @param.comp
      @$emit('click', postParam)
    clear_click: () ->
      for i, r of @param
        @.$set(@param, i, '')
        if i == 'comp'
          @.$set(@param, i, false)
      @$emit('clear', @param)
    change: (v) ->
      @.$set(@param, v.name, v.val)
    departureDatePlanFrom: (v) ->
      @.$set(@param, 'departure_date_plan_from', v.val)
    departureDatePlanTo: (v) ->
      @.$set(@param, 'departure_date_plan_to', v.val)
    pickUpDateFrom: (v) ->
      @.$set(@param, 'pick_up_date_from', v.val)
    pickUpDateTo: (v) ->
      @.$set(@param, 'pick_up_date_to', v.val)
    cutDatetimeFrom: (v) ->
      @.$set(@param, 'cut_datetime_from', v.val)
    cutDatetimeTo: (v) ->
      @.$set(@param, 'cut_datetime_to', v.val)
    checked: (v) ->
      @.$set(@param, 'comp', v)
  }
